var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('r-video',{attrs:{"src":"/video/home.mp4","poster":"img/home/videoPoster.png"}})}
var staticRenderFns = []

export { render, staticRenderFns }